module.exports = __webpack_public_path__ + "static/media/division.cd76df3c.wav";